const domain_backend = process.env.NODE_ENV === "production" ? window.location.origin + "/api" : "http://localhost:8000/api"

export { domain_backend }